document.addEventListener('DOMContentLoaded', () => {
  const triggerWcEvent = (event) => {
    window.jQuery?.(document.body).trigger(event);
  };

  const applyFragments = (fragments) => {
    Object.entries(fragments).forEach(([selector, html]) => {
      document.querySelectorAll(selector).forEach((el) => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        if (temp.firstElementChild) {
          el.replaceWith(temp.firstElementChild);
        }
      });
    });
  };

  function updateCartItem(action, cartItemKey, data) {
    const ajaxUrl = window.wc_cart_fragments_params?.ajax_url || '/wp-admin/admin-ajax.php';

    fetch(ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ action, cart_item_key: cartItemKey, ...data }),
    })
      .then((r) => r.json())
      .then((result) => {
        if (result.success && result.data?.fragments) {
          applyFragments(result.data.fragments);
          if (result.data.cart_hash) {
            sessionStorage.setItem('wc_cart_hash', result.data.cart_hash);
          }
          triggerWcEvent('wc_fragments_refreshed');
        }
      })
      .catch(() => window.location.reload());
  }

  function updateCartItemQty(input) {
    const nameMatch = input.name.match(/cart\[([^\]]+)\]\[qty\]/);
    if (!nameMatch) return;
    updateCartItem('update_cart_item_qty', nameMatch[1], {
      quantity: (parseInt(input.value, 10) || 0).toString(),
    });
  }

  function updateCartItemSize(input) {
    const nameMatch = input.name.match(/cart\[([^\]]+)\]\[pa_size\]/);
    if (!nameMatch) return;
    updateCartItem('update_cart_item_size', nameMatch[1], { size: input.value });
  }

  window.jQuery?.(document.body).on('change added_to_cart', (e) => {
    const { target } = e;

    if (e.type === 'added_to_cart' || (target && (target.matches('input.qty') || target.closest('.c-custom-select--shop')))) {
      if (target?.closest('.cart-drawer')) {
        if (target.matches('input.qty')) {
          updateCartItemQty(target);
          return;
        }
        if (target.name?.includes('[pa_size]')) {
          updateCartItemSize(target);
          return;
        }
      }

      const updateBtn = document.querySelector('[name="update_cart"]');
      const isUpdate = document.querySelector('.cart-hero__is-update');

      if (isUpdate) {
        isUpdate.classList.add('cart-hero__is-update--is-visible');
        setTimeout(() => isUpdate.classList.remove('cart-hero__is-update--is-visible'), 3000);
      }

      if (updateBtn) {
        updateBtn.disabled = false;
        updateBtn.click();
      }
    }
  });

  const stopScroll = setInterval(() => {
    if (window.jQuery) {
      window.jQuery.scroll_to_notices = function () {
        return false;
      };
      clearInterval(stopScroll);
    }
  }, 1000);

  const wrapper = document.querySelector('.woocommerce-notices-wrapper');
  if (!wrapper) return;

  setTimeout(() => {
    wrapper.innerHTML = '';
  }, 5000);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        setTimeout(() => {
          wrapper.innerHTML = '';
        }, 3000);
      }
    });
  });

  observer.observe(wrapper, { childList: true });
});
